import { apiClient } from "shared/utils";

export const deleteComeBackMailingText = async ({ shopId, id }: { shopId: number; id: number }) => {
  const { data } = await apiClient.delete<void>(
    `/${shopId}/triggers/come-back-mailing/text-settings/${id}`
  );

  return data;
};
